function initKtan(root){
  if (root.dataset.ktanInit) return;
  root.dataset.ktanInit = '1';

  var sizeLinks = JSON.parse(root.querySelector('[data-ktan-config]').textContent);

  /* ---- core logic, verbatim ---- */
  function calculateBabyKtanSize(gender, inputSize, country, weight, weightUnit, height, heightUnit) {
    var weightLbs = weightUnit === 'kg' ? Math.round(weight * 2.20462) : weight;
    var heightInches = heightUnit === 'cm' ? Math.round(height * 0.3937) : height;
    var adjustedSize = parseInt(inputSize, 10);

    if (gender === 'male') {
      if (country === 'EU') adjustedSize -= 10;
      if (heightInches <= 62 && adjustedSize > 38) adjustedSize -= 1;

      if (adjustedSize <= 36) {
        if (weightLbs < 131) return 'XS';
        if (weightLbs < 156) return 'S';
        return 'M';
      } else if (adjustedSize <= 42) {
        if (weightLbs < 151) return 'S';
        if (weightLbs < 196) return 'M';
        return 'L';
      } else if (adjustedSize <= 46) {
        if (weightLbs < 151) return 'S';
        if (weightLbs < 181) return 'M';
        return 'L';
      } else {
        if (weightLbs < 151) return 'S';
        if (weightLbs < 181) return 'M';
        if (weightLbs < 221) return 'L';
        return 'XL';
      }
    } else {
      if (country === 'UK') adjustedSize -= 2;
      else if (country === 'EU') adjustedSize -= 30;
      else if (country === 'AUS/NZ' || country === 'AUS') adjustedSize -= 4;

      if (heightInches <= 62 && adjustedSize > 0) adjustedSize -= 2;

      if (adjustedSize <= 0) {
        if (weightLbs < 101) return 'XXS';
        if (weightLbs < 131) return 'XS';
        return 'S';
      } else if (adjustedSize <= 5) {
        if (weightLbs < 140) return 'XS';
        if (weightLbs < 170) return 'S';
        return 'M';
      } else if (adjustedSize <= 7) {
        if (weightLbs < 131) return 'XS';
        if (weightLbs < 161) return 'S';
        if (weightLbs < 181) return 'M';
        return 'L';
      } else if (adjustedSize <= 15) {
        if (weightLbs < 121) return 'XS';
        if (weightLbs < 151) return 'S';
        if (weightLbs < 181) return 'M';
        return 'L';
      } else if (adjustedSize <= 19) {
        if (weightLbs < 151) return 'S';
        if (weightLbs < 181) return 'M';
        return 'L';
      } else {
        if (weightLbs < 151) return 'S';
        if (weightLbs < 181) return 'M';
        if (weightLbs < 231) return 'L';
        return 'XL';
      }
    }
  }


  /* ---- local state (replaces the quiz globals sc*) ---- */
  var state = { gender:'female', country:'US/CAN', units:'inches', ft:'', in:'', cm:'', weight:'', dress:'' };

  var q = function(sel){ return root.querySelector(sel); };
  var els = {
    result: q('[data-result]'), badge: q('[data-badge]'), sizeText: q('[data-size-text]'),
    hint: q('[data-hint]'), cta: q('[data-cta]'), sizeLabel: q('[data-size-label]'),
    heightIn: q('[data-height-inches]'), heightCm: q('[data-height-cm]'),
    weightUnit: q('[data-weight-unit]'), weight: q('[data-weight]'), dress: q('[data-dress]')
  };

  /* ---- glue: maps UI state -> core function (was calcKtanSize) ---- */
  function calcKtanSize(){
    var dress = parseFloat(state.dress);
    var weight = parseFloat(state.weight);
    var height, heightUnit, weightUnit;

    if (state.units === 'inches') {
      var ft = parseFloat(state.ft), inch = parseFloat(state.in);
      if (isNaN(ft) && isNaN(inch)) return null;
      height = (isNaN(ft) ? 0 : ft) * 12 + (isNaN(inch) ? 0 : inch);
      heightUnit = 'in'; weightUnit = 'lbs';
    } else {
      height = parseFloat(state.cm);
      heightUnit = 'cm'; weightUnit = 'kg';
    }

    if (isNaN(dress) || isNaN(weight) || isNaN(height) || height <= 0) return null;

    var country = state.country === 'US/CAN' ? 'US' : state.country; // core has no separate CAN branch
    return calculateBabyKtanSize(state.gender, dress, country, weight, weightUnit, height, heightUnit);
  }

  function setActive(attr, val){
    var nodes = root.querySelectorAll('[data-' + attr + ']');
    for (var i=0;i<nodes.length;i++){ nodes[i].classList.toggle('active', nodes[i].getAttribute('data-'+attr) === val); }
  }

  function render(){
    els.sizeLabel.textContent = state.gender === 'female' ? 'Dress Size' : 'Shirt / Jacket Size';
    els.dress.placeholder = state.gender === 'female' ? '8' : '40';

    var inches = state.units === 'inches';
    els.heightIn.classList.toggle('hidden', !inches);
    els.heightCm.classList.toggle('hidden', inches);
    els.weightUnit.textContent = inches ? 'lbs' : 'kg';
    els.weight.placeholder = inches ? '150' : '68';

    setActive('gender', state.gender);
    setActive('country', state.country);
    setActive('units', state.units);

    var size = calcKtanSize();
    if (size) {
      els.badge.textContent = size;
      els.sizeText.textContent = size;
      els.result.classList.remove('hidden');
      els.hint.classList.add('hidden');
      var link = sizeLinks[size];
      if (link) { els.cta.href = link; els.cta.textContent = 'Shop size ' + size; els.cta.classList.remove('hidden'); }
      else { els.cta.classList.add('hidden'); }
    } else {
      els.result.classList.add('hidden');
      els.hint.classList.remove('hidden');
      els.cta.classList.add('hidden');
    }
  }

  function onClick(attr){
    var nodes = root.querySelectorAll('[data-' + attr + ']');
    for (var i=0;i<nodes.length;i++){
      (function(node){
        node.addEventListener('click', function(){ state[attr] = node.getAttribute('data-'+attr); render(); });
      })(nodes[i]);
    }
  }
  onClick('gender'); onClick('country'); onClick('units');

  function onInput(sel, key){
    var el = q(sel);
    if (el) el.addEventListener('input', function(){ state[key] = el.value; render(); });
  }
  onInput('[data-ft]','ft'); onInput('[data-in]','in'); onInput('[data-cm]','cm');
  onInput('[data-weight]','weight'); onInput('[data-dress]','dress');

  render();
}

function initAllKtan(scope){
  (scope || document).querySelectorAll('.size-calc').forEach(initKtan);
}

initAllKtan();
document.addEventListener('shopify:section:load', function(e){ initAllKtan(e.target); });

document.addEventListener('click', function (e) {
  var open = e.target.closest('[data-ktan-open]');
  if (open) {
    open.closest('.ktan-modal').querySelector('[data-ktan-dialog]').showModal();
    return;
  }
  if (e.target.closest('[data-ktan-close]')) {
    e.target.closest('dialog').close();
    return;
  }
  if (e.target.matches('[data-ktan-dialog]')) e.target.close();
});